export const ALERT = 'alert';
export const CLEAR_CONSOLE = 'clear';
export const HELP = 'help';
export const NOTIFICATION = 'notification';
export const REFRESH = 'refresh';
export const DUPLICATE = 'duplicate';
export const OPEN_TAB = 'open_tab';
